<template>
  <div>
    <DialogoLlamame ref="llamame" :titulo="this.titulo" />
    <DialogoPreAfi ref="refModDatos" :titulo="titulo" :type="type" :key="componentKey" :form-key="formKey" />
    <!--     <DialogoBlockTramite ref="redDialogoBlock" /> -->
    <v-hover v-slot="{ hover }">
      <v-card outlined class="rounded-xl" style="border: 1px solid #eeeeee; cursor: pointer;" :elevation="hover ? 5 : 0"
        @click.stop="abrirDialogoEditar">
        <v-card-title class="d-flex primary--text font-weight-bold mx-3"
          :class="($vuetify.breakpoint.mdAndDown) ? 'text-h6' : 'text-h5'" style="word-break: keep-all;">
          Datos personales
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab color="primary lighten-1" small :loading="loading"
                class="elevation-0 ml-auto" @click.stop="abrirDialogoEditar">
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            <span>Editar datos personales</span>
          </v-tooltip>
        </v-card-title>
        <v-card-text class="d-flex flex-column align-center justify-center ">
          <v-row class="d-flex justify-center mx-4">
            <v-avatar size="210" tile style="position: relative;" class="my-3">
              <v-img v-if="user.fotocarnet" :src="`data:image/png;base64,${user.fotocarnet}`"></v-img>
              <v-img v-else src="@/assets/blank-user-profile.png"></v-img>
            </v-avatar>
            <v-col cols="12" md="12" class="text-center">
              <div class="my-2 font-weight-bold black--text text--darken-1 text-body-1 ">{{ user.nombres }} {{
                user.apellido
              }}
              </div>
              <div class="my-2 font-weight-bold black--text text-body-1">Nº {{ pronombre }}: {{
                user.nroafi
              }}
              </div>
              <v-spacer></v-spacer>
              <div class="font-weight-bold black--text text--darken-1 text-body-1 my-2">{{ user.tipdoc }}: {{
                user.nrodoc }}
              </div>
              <div class="my-2 font-weight-regular black--text text-body-1 ">
                Distrito: {{
                  user.desdistrito }}</div>
              <div class="font-weight-regular black--text text-body-1 mt-2">Estado:
                {{ user.estado }}
              </div>
            </v-col>
            <div class="pb-5 d-flex flex-column align-center" style="width: 180px;">
              <div class="d-flex align-center text-center font-weight-bold white--text text-body-2 pa-2 px-8"
                style="background-color: #00A0DF; min-width: 130px; min-height: 38px; justify-content: center;">
                {{ textoNivel }}
              </div>
              <div v-if="user.nivel_validez == 'P'"
                class="d-flex flex-row align-center py-2 px-2 font-weight-bold black--text text-body-2"
                style="border: 2px solid #00A0DF; min-width: 130px; min-height: 38px; justify-content: center;">
                PERMANENTE
              </div>
            </div>
          </v-row>
        </v-card-text>
      </v-card>
    </v-hover>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DialogoLlamame from '@/components/dialogos/DialogoLlamame'
import DialogoPreAfi from '@/components/dialogos/DialogoPreAfi'
import DialogoCard from '@/components/dialogos/DialogoCard.vue'

export default {
  name: "AfiliadoCard",
  components: {
    DialogoPreAfi,
    DialogoLlamame,
    DialogoCard
  },
  data() {
    return {
      titulo: '',
      tipo: '',
      type: '',
      ancho: '',
      fab: false,
      itemGrid: '',
      cabecera: '',
      loading: false,
      showBtn: false,
      paso: '',
      ps: -1,
      componentKey: 0,
      formKey: 0,
    }
  },

  methods: {

    ...mapActions('dataUser', ['copiarFamiliares', 'deleteAllFam', 'guardarDatosPersonales', 'guardarDatosFamiliares', 'preparaFormPersonales', 'deleteAllArchFam']),
    ...mapActions('notificaciones', ['showSnack', 'hideSnack']),
    //...mapActions('tramites', ['getTramites', 'permitirModTramites']),
    ...mapActions('tramites', ['getTramites']),

    abrirDialogoEditar() {
      // Llamada async a getTramites
      this.loading = true;
      this.getTramites().then(() => {
        // Verificar si hayModPendiente es true
        if (this.hayModPendiente) {
          this.showSnack({
            message: "Tenés trámites pendientes de aprobación.",
            type: "400",
          });
        } else {
          this.titulo = "Editar mi legajo";
          this.type = "modificacion";

          // Restablece el estado interno del componente
          if (this.$refs.refModDatos) {
            this.$refs.refModDatos.resetState();
            this.$refs.refModDatos.abrirDialogo();
          } else {
            console.error("Referencia a refModDatos no encontrada.");
          }
        }
      }).catch(error => {
        console.error("Error al obtener los trámites:", error);
      }).finally(() => {
        this.loading = false;
      });


    },

    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    }

  },
  computed: {
    ...mapGetters('auth', ['user', 'emailAuth', 'esActivo', 'tienedeuda']),
    ...mapGetters('common', ['estadoCivil', 'tipoNacionalidad']),
    ...mapGetters('tramites', ['hayModPendiente']),
    ...mapGetters('opcionNivel', ['opcionNivelAfiliado']),

    pronombre() {
      switch (this.user.sexo) {
        case "M":
          return "Afiliado"
        case "F":
          return "Afiliada"
        default:
          return "Afiliadx"
      }
    },
    textoNivel() {
      switch (this.user.nivel) {
        case 1:
          return "NIVEL 1";
        case 2:
          if (this.user.aporteReducido == "") {
            return "NIVEL 2";
          }
          else {
            return this.user.aporteReducido.toUpperCase();
          }
        case 3:
          return "NIVEL 3";
        case 4:
          return "NIVEL 4";
        case 5:
          return "NIVEL 5";
        default:
          return "NIVEL X";
      }
    }
  },
}
</script>

<style>
.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
